export default __webpack_public_path__ + "CircularCustCapNum-LightItalic.104604bffb4949fd10a22959d0a868f7.ttf";